import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { strings } from '../../../resources/strings';
import { ReportService } from '../../Reports/ReportService';
import { GetSimplePackingLabelInput } from './GetSimplePackingLabelInput';

export class GetSimplePackingLabelService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  fileHandle = (input: GetSimplePackingLabelInput) => {
    this.http.postToDownloadFile<GetSimplePackingLabelInput>(
      `${this.baseUrlSislogApi}/v2/simple-packing-label/file`,
      input
    ).then(result => {
      this.report.download(result, `${strings.LabelsOfPackingSimple}.zpl`);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }

  pdfHandle = (input: GetSimplePackingLabelInput) => {
    this.http.postToDownloadFile<GetSimplePackingLabelInput>(
      `${this.baseUrlSislogApi}/v2/simple-packing-label/pdf`,
      input
    ).then(result => {
      this.report.openPdf(result);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }
}